/** Plein écran de chargement (logo qui pulse), remplace le `SplashScreen` de Minimal. */
export const SplashScreen = () => (
  <div
    aria-label="Chargement"
    className="fixed inset-0 z-[9998] flex items-center justify-center bg-muted"
    data-slot="splash-screen"
    role="status"
  >
    <img alt="Logo" className="h-[75px] w-[255px] animate-pulse object-contain" src="/logo/logo.png" />
  </div>
);
